import React from 'react';
import { NavLink } from 'react-router-dom';
import { Popover, Tag } from 'antd';
import Translated from 'components/Translated';
import ProfileAvatar from 'components/ProfileAvatar';
import StyledUserProfile from './UserProfile.styled';

const UserProfile = ({
    userData,
    userLogout,
}) => {
    const userDataProperty = userData.data;

    function emptyTokenAnData() {
        userLogout();
    }

    return (
        <StyledUserProfile>
            <div className="gx-flex-row gx-align-items-center gx-avatar-row">

                <Popover
                    placement="bottomRight"
                    content={(
                        <ul className="gx-user-popover">
                            <li>
                                <NavLink to="/profile">
                                    <i className="la la-user-edit la-lg" /> <Translated id="userProfile.editAccount" />
                                </NavLink>
                            </li>
                            <li>
                                <button type="button" className="gx-buttonless gx-p-0" onClick={emptyTokenAnData}>
                                    <i className="la la-sign-out la-lg" /> <Translated id="userProfile.logout" />
                                </button>
                            </li>
                        </ul>
                    )}
                    trigger="hover"
                    className="gx-d-flex gx-align-items-center"
                >
                    <ProfileAvatar user={userDataProperty} size={40} />
                    <div>
                        <span className="gx-avatar-name">{`${userDataProperty ? userDataProperty.first_name : ''} ${userDataProperty ? userDataProperty.last_name : ''}`} <i className="la la-angle-down gx-fs-xxs" /></span>
                        <footer>{userData.operator !== null && <Tag color="blue" className="gx-m-0"><i className="la la-user-cog" /> {userData.operator.name}</Tag>}</footer>
                    </div>
                </Popover>
            </div>
        </StyledUserProfile>
    );
};

export default UserProfile;
